<template>
  <div id="go-home" v-if="hasHome" @click.stop="goBack">
    <!-- 首页按钮 -->
    <img src="@/assets/img/icon-go-home.png" alt="" />
  </div>
</template>

<script>
export default {
  name: 'GoHome',
  props: {
    top: {
      default: '5.12rem',
      type: String
    },
    left: {
      default: '0',
      type: String
    }
  },
  data() {
    return {
      hasHome: true
    }
  },
  mounted() {
    this.$EventBus.$on('hasHome', has => (this.hasHome = has))
  },
  beforeDestroy() {
    this.$EventBus.$off('hasHome')
  },
  methods: {
    goBack() {
      // this.$router.push('/Dashboard')
      this.$EventBus.$emit('showNav', true)
    }
  }
}
</script>

<style lang='scss' scope>
#go-home {
  width: 0.98rem /* 56/100 */;
  height: 0.98rem /* 56/100 */;
  border-radius: 0.15rem 0 0 0.15rem;

  position: absolute;
  z-index: 1005;
  background-color: rgba(0, 0, 0, 0.5);
  // top: var(--top);
  top: 1.45rem;
  right: 0rem;
  transform: translateY(-50%);
  // margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 0.61rem;
    height: 0.43rem;
  }
}
</style>